import BaseMessageHandler from 'messages/BaseMessageHandler';
import { closeModal, openModal } from 'actions/modal';
import { confirmAddSettlement, confirmUpdateSettlement } from 'api/settlements';
import { changeDataForceUpdate } from 'actions/getData';
import tableNames from 'constants/tableNames';
import RpcTypes from 'constants/rpcTypes';

export default class Settlement_Confirm2FARequest extends BaseMessageHandler {
  default = () => {
    const { dispatch, response } = this;
    const messageId = response.data.messages[0]?.id;
    const rpcType = response.data.messages[0]?.payload?.action;

    const onSendHandler = ({ validationCode, authToken }) => {
      const rpcAction = rpcType === RpcTypes.Settlement_CreateConfirmed
        ? confirmAddSettlement
        : confirmUpdateSettlement;

      rpcAction(messageId, { validationCode, authToken, }).then(() => {
        dispatch(changeDataForceUpdate(tableNames.settlements, true));
        dispatch(closeModal());
      });
    };

    dispatch(
      openModal({
        modalId: 'TwoFactorAuth',
        content: {
          authToken: response.data.authToken,
          onSendForm: onSendHandler,
        }
      }),
    );
  };
}
